import * as $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { RubriqueContratDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueContratDto";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { RubriqueGeneraleDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueGeneraleDto";
import dateHelper from "../../Helper/dateHelper";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalUpdate from "./modalUpdate/modalUpdate";

@Component({
    components: {
        ModalUpdate: require("./modalUpdate/modalUpdate.vue.html")
    },
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as ParametresSpecifiquesComponent);
            vm.init();
        });
    }
})
export default class ParametresSpecifiquesComponent extends Vue {
    public isModified = false;

    public rubriquesGenerales: RubriqueGeneraleDto[] = [];
    public rubriquesGeneralesOrigine: RubriqueGeneraleDto[] = [];
    public rubriquesGeneralesFiltered: RubriqueGeneraleDto[] = []

    public parametresSpecifiques: RubriqueDto[] = [];

    public currentOrderColumn = "CodeRubrique";
    public orderingDesc = true;
    public searchfilter = "";

    public libelleSociete = "";
    public isLoading = 0;

    public modalUpdate?: ModalUpdate = undefined;

    public canDoTransfert = false;

    public init(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }
        this.searchfilter = "";
        this.isModified = false;
        if (ParametresInstance.societeCourante.Libelle != undefined) {
            this.libelleSociete = ParametresInstance.societeCourante.Libelle;
        }
        this.getRubriquesGenerales();
        this.getRubriquesSpecificques();
    }

    public getRubriquesGenerales(): void {
        this.isLoading++;
        ServicesFactoryInstance.RubriquesService.getListeRubriquesGenerales(data => {
            this.rubriquesGenerales = data;
            this.rubriquesGeneralesOrigine = JSON.parse(JSON.stringify(data));
            this.doFilter();
            this.isLoading--;

            this.canDoTransfert = ParametresInstance.userIsCombinedAuthorized(["Administrateur", "AdministrateurPST"])
                && FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.TransfertSql);
        }, () => this.isLoading--);
    }

    public getRubriquesSpecificques(): void {
        this.isLoading++;
        ServicesFactoryInstance.ParametreSpecifiqueService.getListe(data => {
            this.parametresSpecifiques = data;
            this.isLoading--;
        }, () => this.isLoading--);
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;

        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.currentOrderColumn;
        if (this.rubriquesGeneralesFiltered != undefined) {
            this.rubriquesGeneralesFiltered = this.rubriquesGeneralesFiltered.sort(function (a, b) {

                // Gestion des valeurs null
                if (a[columnName] === null) {
                    return 1;
                }

                if (b[columnName] === null) {
                    return -1;
                }

                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public doFilter(): void {
        if (this.searchfilter == undefined || this.searchfilter == "") {
            this.rubriquesGeneralesFiltered = this.rubriquesGenerales;
        } else {
            this.rubriquesGeneralesFiltered = this.rubriquesGenerales.filter(s =>
                s.LibelleRubrique != undefined && (s.LibelleRubrique.toUpperCase().indexOf(this.searchfilter.toUpperCase()) >= 0) ||
                (s.NumeroSequence != undefined && s.NumeroSequence.toString().toUpperCase().indexOf(this.searchfilter.toUpperCase()) >= 0) ||
                (s.CodeRubrique != undefined && s.CodeRubrique.toString().toUpperCase().indexOf(this.searchfilter.toUpperCase()) >= 0));
        }
        this.doOrder();
    }

    public peutAjouter(rubrique: RubriqueGeneraleDto): boolean {
        if (rubrique.EstIncluseDansScenario || this.parametresSpecifiques.filter(r => r.CodeRubrique == rubrique.CodeRubrique).length > 0) {
            return false;
        }

        return true;
    }

    public ajouter(rubrique: RubriqueGeneraleDto): void {
        if (!this.peutAjouter(rubrique)) {
            return;
        }
        const param: RubriqueContratDto = { CodeRubrique: rubrique.CodeRubrique, CodeSociete: undefined, Id: 0, NumeroContrat: 0, NumeroSalarie: 0, Value: rubrique.Valeur };

        this.isLoading++;
        ServicesFactoryInstance.ParametreSpecifiqueService.create(param, () => {
            NotificationServiceInstance.SendSuccess("Création effectuée avec succès.");
            this.getRubriquesSpecificques();
            this.isLoading--;
        }, () => this.isLoading--);

        this.$forceUpdate();
    }

    public retirer(rubrique: RubriqueContratDto): void {
        if (rubrique.Id == 0) {
            return;
        }

        this.isLoading++;
        ServicesFactoryInstance.ParametreSpecifiqueService.delete(rubrique.Id, () => {
            this.parametresSpecifiques.forEach((item, index) => {
                if (item === rubrique) {
                    this.parametresSpecifiques.splice(index, 1);
                }
            });
            NotificationServiceInstance.SendSuccess("Suppression du paramètre spécifique effectuée avec succès.");
            this.isLoading--;
        }, () => this.isLoading--);

        this.$forceUpdate();
    }

    public updateParamSpecifique(rubrique: RubriqueDto): void {
        if (rubrique.Id == 0) {
            return;
        }

        this.isLoading++;
        const rubContrat: RubriqueContratDto = { CodeRubrique: rubrique.CodeRubrique, Id: rubrique.Id, NumeroContrat: 0, NumeroSalarie: 0, Value: rubrique.DefaultValue, CodeSociete: undefined };
        ServicesFactoryInstance.ParametreSpecifiqueService.update(rubContrat, () => {
            NotificationServiceInstance.SendSuccess("Modification du paramètre spécifique effectuée avec succès.");
            this.isLoading--;
        }, () => this.isLoading--);
    }

    public modifierValeurRubrique(rubrique: RubriqueGeneraleDto): void {
        if (!rubrique || !rubrique.CodeRubrique) {
            return;
        }

        if (rubrique.EstIncluseDansScenario) {
            this.alerteModificationParametresGeneraux(rubrique);
        } else {
            this.updateRubriqueValeur(rubrique);
        }
    }

    public alerteModificationParametresGeneraux(rubrique: RubriqueGeneraleDto): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "En modifiant la valeur de la rubrique, vous allez également mettre à jour les scénarios et les contrats actifs associés.<BR><BR> Souhaitez-vous continuer ?",
            canClose: true,
            yesText: "Oui",
            noText: "Non",
            callBackYes: () => {
                this.updateRubriqueValeur(rubrique);
            },
            callBackNo: () => {
                const rubriqueOrigine = this.rubriquesGeneralesOrigine.filter(r => r.CodeRubrique == rubrique.CodeRubrique)[0];
                if (rubriqueOrigine) {
                    rubrique.Valeur = rubriqueOrigine.Valeur;
                }
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public updateRubriqueValeur(rubrique: RubriqueGeneraleDto): void {
        this.isLoading++;
        ServicesFactoryInstance.RubriqueService.updateRubriqueValeur(rubrique, () => {
            if (rubrique.EstIncluseDansScenario) {
                // Actualisation des paramètres généraux instanciés côté front et succeptibles d'être impactés.
                ParametresInstance.refreshListeQualifications();
                ParametresInstance.refreshListeConventions();
                ParametresInstance.refreshListeRemunerations();

                NotificationServiceInstance.SendSuccess("La rubrique générale, les scénarios associés et les contrats actifs ont bien été mis à jour.");
            } else {
                NotificationServiceInstance.SendSuccess("La rubrique générale a bien été mise à jour.");
            }

            this.getRubriquesGenerales();
            ParametresInstance.refreshListeRubriques();

            this.isLoading--;
        }, () => {
            this.isLoading--;
        });
    }

    public afficheParametresAssocies(idRubrique: number): void {
        if (this.modalUpdate == undefined) {
            this.modalUpdate = this.$refs.modalUpdate as ModalUpdate;
        }
        this.modalUpdate.Init(idRubrique);
        $("#modalUpdate").modal("show");
    }

    public annuler(): void {
        this.init();
    }

    public openModaleTransfert(rubrique: RubriqueGeneraleDto): void {
        const modalTransfert: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Cette action va envoyer votre élément vers la liste d'attente des transferts SQL. Souhaitez-vous continuer ?",
            showDialog: true,
            title: "Confirmation",
            callBackYes: () => {
                this.transfertRubrique(rubrique);
            }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalTransfert);
    }

    public transfertRubrique(rubrique: RubriqueGeneraleDto): void {
        if (this.canDoTransfert && rubrique != null) {
            ServicesFactoryInstance.EntiteEnAttenteService.addRubriqueToList(rubrique.Id, () => {
                NotificationServiceInstance.SendSuccess("L'élément <strong>" + rubrique.LibelleRubrique + "</strong> a bien été ajouté à la liste d'attente des transferts SQL.");

                this.init();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/parametresSpecifiques/parametresSpecifiques.ts